import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';


if (environment.production) {
  enableProdMode();
}
const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: '5e4bf026-0878-42c0-9be6-6de937f19287', // Substitua pela sua chave de instrumentação do Application Insights
  }
});
appInsights.loadAppInsights();
appInsights.trackPageView()
platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
